import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class DeleteUsersCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }
  async run(user_ids): Promise<any> { 
    let args = {user_ids: user_ids};
    try {
      return await this.dispatcher.dispatch('delete.users', args);
    } catch(error) {
      console.error('Error al eliminar usuarios', error)
    }
  }
}
